import type { Faro } from '@grafana/faro-web-sdk';

import type { TelemetryContextState } from '../contexts/TelemetryContext';
import TelemetryContext from '../contexts/TelemetryContext';

interface TelemetryProviderProps {
  children: React.ReactNode;
  instance: Faro;
}

const TelemetryProvider = ({ children, instance }: TelemetryProviderProps) => {
  const setUser = (userId: string) => {
    if (instance) {
      instance.api.setUser({ id: userId });
    }
  };

  const contextValue: TelemetryContextState = {
    instance,
    setUser,
  };

  return (
    <TelemetryContext.Provider value={contextValue}>
      {children}
    </TelemetryContext.Provider>
  );
};

export default TelemetryProvider;
